<template>
  <div>
    <!--    代理列表-->
    <!--    {{$t('msg.index')}}-->
    <div class="section-card">
      <div class="button-block">
        <div class="tag-chile">
          <el-tag type="danger"><span translate="no">{{ searchUsername }}</span> - {{ $t('msg.agent_list') }}</el-tag>
          <span v-if="noCheckDevice()">
            <el-divider direction="vertical" v-if="searchUsername == username"></el-divider>
            <el-link type="primary" @click="addProxyDialogFormVisible"
                     v-if="searchUsername == username && level !== 2">{{ addMsg }}
            </el-link>
            <el-divider direction="vertical" v-if="level !== 2"></el-divider>
            <el-link type="primary" @click="getPorxyUserList(1)" v-if="level !== 2">{{ $t('msg.Reload_agent_List') }}</el-link>
          </span>
          <el-dropdown split-button type="primary" size="mini" @command="proxyHandleCommand" v-if="checkDevice()"
                       trigger="click">
            <span class="el-dropdown-link">
              {{ $t('msg.AgentList_Menu') }}
            </span>
            <el-dropdown-menu slot="dropdown" style="width: 50%">

              <el-dropdown-item divided :command="item.label" v-for="item in showProxyAct" :key="item.msg" >{{ item.msg }}</el-dropdown-item>

            </el-dropdown-menu>
          </el-dropdown>

          <el-dialog class="proxyBlock" width="80%" :title="addMsg" :visible.sync="porxyDialogFormVisible"
                     :close-on-click-modal="false" :fullscreen="checkDevice()">
            <el-form :model="porxyForm" :rules="level === 1 ? porxyRulesNoPrice : porxyRules" ref="proxy" label-width="25%">
              <el-form-item :label="$t('msg.User_Name2')" prop="username">
                <el-input v-model="porxyForm.username"></el-input>
              </el-form-item>
              <el-form-item :label="$t('msg.Password2')" prop="password">
                <el-input v-model="porxyForm.password" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item :label="$t('msg.Set_score2')" prop="price" v-if="level !== 1">
                <el-tag type="danger" translate="no">Max value {{ coins }}</el-tag>
                <br/>
                <el-input v-model="porxyForm.price" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item :label="$t('msg.Name2')">
                <el-input v-model="porxyForm.realname" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item :label="$t('msg.Tel')" prop="pnum">
                <el-input v-model="porxyForm.pnum" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item :label="$t('msg.Description1')">
                <el-input v-model="porxyForm.description" autocomplete="off"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="porxyDialogFormVisible = false">{{ $t('msg.Cancel') }}</el-button>
              <el-button type="primary" @click='createProxy'>{{ $t('msg.OK2') }}</el-button>
            </div>
          </el-dialog>
        </div>
      </div>

      <el-table :data="porxyTableData" tooltip-effect="dark" size="mini"
                stripe border
                :header-cell-style="{background:'#f5f7fa', color:'#303133', fontSize: '12px', fontWeight: '600'}"
                class="tableAuto">
        <el-table-column prop="username" :label="$t('msg.User_Name2')" width="120px">
          <template slot-scope="scope">
            <el-link type="primary" @click="chiAccountList(scope.row.username)" v-if="level !== 2">{{ scope.row.username }}</el-link>
            <span v-else>{{ scope.row.username }}</span>
          </template>

        </el-table-column>
        <el-table-column prop="price" :label="$t('msg.Score')">
        </el-table-column>
        <el-table-column prop="realname" :label="$t('msg.Name1')">
        </el-table-column>
        <el-table-column prop="pnum" :label="$t('msg.Tel')" width="105px">
        </el-table-column>
        <el-table-column prop="description" :label="$t('msg.Description1')" width="150px" :show-overflow-tooltip="true">
        </el-table-column>

        <el-table-column prop="username" :label="$t('msg.User_Name2')" v-if="checkDevice()" width="120px">
          <template slot-scope="scope">
            <el-link type="primary" @click="chiAccountList(scope.row.username)" v-if="level !== 2">{{ scope.row.username }}</el-link>
            <span v-else>{{ scope.row.username }}</span>
          </template>

        </el-table-column>
        <el-table-column :label="$t('msg.Operation')" :min-width="getProxyColWidth()">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" @click="editProxy(scope.row.username)"
                       v-if="searchUsername == username">{{ $t('msg.edit') }}
            </el-button>
            <el-button type="primary" size="mini" @click="setScore(scope.row.username, 1)"
                       v-if="level === 0 && scope.row.level === 1">{{ $t('msg.Set_score1') }}
            </el-button>
            <el-button type="warning" size="mini" @click="SetScoreLog(scope.row.username, 1)">{{ $t('msg.score_log') }}
            </el-button>
            <span v-if="searchUsername == username">
              <el-button type="warning" size="mini" @click="banProxy(scope.row.username)"
                         v-if="scope.row.state == 0">{{ $t('msg.disable') }}</el-button>
              <el-button type="danger" size="mini" @click="permissionProxy(scope.row.username)"
                         v-if="scope.row.state != 0">{{ $t('msg.enable') }}</el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange"
                       :total="porxyTotal">
        </el-pagination>
      </div>
    </div>
    <!--    玩家列表-->
    <div class="section-card">

      <div class="button-block">
        <div class="tag-chile">
          <el-tag type="danger"><span translate="no">{{ searchUsername }}</span> - {{ $t('msg.player_list') }}</el-tag>
          <span v-if="noCheckDevice()">
            <el-divider direction="vertical" v-if="searchUsername == username"></el-divider>
            <el-link type="primary" @click="addDialogFormVisible"
                     v-if="searchUsername == username && level !== 1">
              {{ $t('msg.Add_Player') }}
            </el-link>
            <el-divider direction="vertical"></el-divider>
            <el-link type="primary" @click="allQueryReport(searchUsername, 0)">
              {{ $t('msg.Player_total_report') }}
            </el-link>
            <el-divider direction="vertical" v-if="searchUsername == username"></el-divider>
            <el-link type="primary" @click="permissionAllUser"
                     v-if="searchUsername == username">
              {{ $t('msg.Enable_all_player') }}
            </el-link>
            <el-divider direction="vertical" v-if="searchUsername == username"></el-divider>
            <el-link type="primary" @click="banAllUser" v-if="searchUsername == username">
              {{ $t('msg.Disable_all_player') }}
            </el-link>
            <el-divider direction="vertical"></el-divider>
            <el-link type="primary" @click="getUserList(1)">{{ $t('msg.Reload_player_List') }}</el-link>
          </span>
          <el-dropdown split-button type="primary" size="mini" @command="userHandleCommand" v-if="checkDevice()" :popper-append-to-body="false"
                       trigger="click">
            <span class="el-dropdown-link">
              {{ $t('msg.PlayerList_Menu') }}
            </span>
            <el-dropdown-menu slot="dropdown" style="width: 50%">

              <el-dropdown-item divided :command="item.label" v-for="item in userAct" :key="item.msg">{{ item.msg }}</el-dropdown-item>

            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-dialog class="proxyBlock" :width="checkDevice()? '100%' : '80%'" :title="$t('msg.Add_players')" :visible.sync="dialogFormVisible"
                   :close-on-click-modal="false" :fullscreen="checkDevice()">
          <div><b>{{ $t('msg.User_agent') }} </b></div>
          <el-tag type="info" translate="no"> {{ searchUsername }}</el-tag>
          <div style="margin:8px 0"><b>分配 User ID：</b><span style="color:#67C23A"><b translate="no">{{ pendingUserId }}</b></span></div>
          <el-form :model="userForm" :rules="userRules" ref="user" label-width="25%">
            <el-form-item :label="$t('msg.Password2')" prop="password">
              <el-input v-model="userForm.password" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$t('msg.Set_score2')" prop="price">
              <el-tag type="danger" translate="no">Max value {{ coins }}</el-tag>
              <br/>
              <el-input v-model="userForm.price" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$t('msg.Name2')">
              <el-input v-model="userForm.realname" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$t('msg.Tel')" prop="pnum">
              <el-input v-model="userForm.pnum" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$t('msg.Description1')">
              <el-input v-model="userForm.description" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">{{ $t('msg.Cancel') }}</el-button>
            <el-button type="primary" @click="createUser">{{ $t('msg.OK2') }}</el-button>
          </div>
        </el-dialog>
      </div>
      <el-table :data="userTableData" tooltip-effect="dark" size="mini"
                stripe border
                :header-cell-style="{background:'#f5f7fa', color:'#303133', fontSize: '12px', fontWeight: '600'}">
        <el-table-column prop="user_id" :label="$t('msg.User_Name2')"  width="90px">
          <template slot-scope="scope">
            <el-link type="primary" @click="userSearch(scope.row.user_id)">{{ scope.row.user_id }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="lastlogin" :label="$t('msg.DisOnlineDay')" width="120px">
        </el-table-column>
        <el-table-column prop="realname" :label="$t('msg.Name1')">
        </el-table-column>
        <el-table-column prop="pnum" :label="$t('msg.Tel')" width="105px">
        </el-table-column>
        <el-table-column prop="description" :label="$t('msg.Description1')" width="120px" :show-overflow-tooltip="true">
        </el-table-column>

        <el-table-column prop="user_id" :label="$t('msg.User_Name2')" v-if="checkDevice()"  width="90px">
          <template slot-scope="scope">
            <el-link type="primary" @click="userSearch(scope.row.user_id)">{{ scope.row.user_id }}</el-link>
          </template>
        </el-table-column>
        <el-table-column :label="$t('msg.Operation')" :min-width="getUserColWidth()">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" @click="setScore(scope.row.user_id, 0)"
                       v-if="searchUsername == username">{{ $t('msg.Set_score1') }}
            </el-button>
            <el-button type="warning" size="mini" @click="SetScoreLog(scope.row.user_id, 0)">{{ $t('msg.score_log') }}
            </el-button>
            <el-button type="warning" size="mini" @click="editUser(scope.row.user_id)"
                       v-if="searchUsername == username">{{ $t('msg.edit') }}
            </el-button>
            <el-button type="warning" size="mini" @click="queryReport(scope.row.user_id, 0)">{{ $t('msg.report') }}
            </el-button>
            <span v-if="searchUsername == username">
              <el-button type="warning" size="mini" @click="banUser(scope.row.user_id)"
                         v-if="scope.row.state == 0">{{ $t('msg.disable') }}</el-button>
              <el-button type="danger" size="mini" @click="permissionUser(scope.row.user_id)"
                         v-if="scope.row.state != 0">{{ $t('msg.enable') }}</el-button>
                          </span>

          </template>

        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination layout="prev, pager, next" :page-size="10" @current-change="userHandleCurrentChange"
                       :total="userTotal">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetPorxyUserList,
  CreateProxy,
  GetUserList,
  CreateUser,
  PermissionUser,
  BanUser,
  BanProxy,
  PermissionProxy,
  getUserId
} from "../api";
import RSAEncrypt from '../utils/rsaEncrypt'
import { isMobile } from '../utils/device'

var LxStr = function (str) {
  if (str) {
    var arr = str.split('');
    var flag = true;
    for (var i = 1; i < arr.length - 1; i++) {
      var firstIndex = arr[i - 1].charCodeAt();
      var secondIndex = arr[i].charCodeAt();
      var thirdIndex = arr[i + 1].charCodeAt();
      // thirdIndex - secondIndex == 1;
      // secondIndex - firstIndex==1;
      if ((thirdIndex - secondIndex == 1) && (secondIndex - firstIndex == 1)) {
        flag = false;
      }
    }
    return flag;
  }
}
export default {
  name: "AccountList",
  data() {
    return {
      username: "",
      addMsg: this.$t('msg.Add_Agent'),
      searchUsername: "",
      level: JSON.parse(localStorage.getItem('userInfo')).level,

      porxyTableData: [],
      porxyPage: 1,
      porxyTotal: 0,
      porxyDialogFormVisible: false,
      porxyForm: {
        'username': '',
        'password': '',
        'price': '',
        'realname': '',
        'pnum': '',
        'description': ''
      },
      porxyRules: {
        username: [
          {required: true, message: this.$t('msg.Please_enter_your_account_number'), trigger: 'blur'},
          {min: 7, max: 16, message: this.$t('msg.The_length_is_716_characters'), trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              // const reg = /^[\u4E00-\u9FA5A-Za-z0-9]+$/ 带有下划线_
              const reg = /^[A-Za-z0-9]+$/
              if (!reg.test(value)) {
                callback(new Error(this.$t('msg.Username_format_hint')))
              } else {
                callback()
              }
            },
            trigger: "blur"
          }
        ],
        password: [
          {required: true, message: this.$t('msg.Please_enter_your_password'), trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (value.length < 6 || value.length > 15) {
                callback(new Error(this.$t('msg.Password_format_hint')));
              } else if (value.search(/\d/) == -1) {
                callback(new Error(this.$t('msg.Password_format_hint')));
              } else if (value.search(/[a-zA-Z]/) == -1) {
                callback(new Error(this.$t('msg.Password_format_hint')));
              } else if (value.search(/[^a-zA-Z0-9\!\_-]/) != -1) {
                callback(new Error(this.$t('msg.Password_format_hint')));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        price: [
          {
            validator: (rule, value, callback) => {
              if (!value) { callback(); return; }
              if (isNaN(Number(value, 10))) {
                callback(new Error(this.$t('msg.Score_must_be_numeric')));
              }
              if (value.indexOf(".") != -1 && value.split('.').length > 2) {
                callback(new Error(this.$t('msg.Please_enter_the_correct_score_format'))) //防止输入多个小数点
              } else if (value.indexOf(".") != -1 && value.split('.')[1].length > 3) {
                callback(new Error(this.$t('msg.Enter_up_to_three_decimal_places'))) //小数点后三位
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        pnum: [
          {min: 11, max: 11, message: this.$t('msg.The_length_is_11_characters'), trigger: 'blur'},
        ]
      },
      userTableData: [],
      userPage: 1,
      userTotal: 0,
      userForm: {
        'password': '',
        'price': '',
        'realname': '',
        'pnum': '',
        'description': ''
      },
      userRules: {
        username: [
          {required: true, message: this.$t('msg.Please_enter_your_account_number'), trigger: 'blur'},
          {min: 6, max: 16, message: this.$t('msg.The_length_is_716_characters'), trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              const reg = /^[A-Za-z0-9]+$/
              if (!reg.test(value)) {
                callback(new Error(this.$t('msg.Username_format_hint')))
              } else {
                callback()
              }
            },
            trigger: "blur"
          }
        ],
        password: [
          {required: true, message: this.$t('msg.Please_enter_your_password'), trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (value.length < 6 || value.length > 15) {
                callback(new Error(this.$t('msg.Password_format_hint')));
              } else if (value.search(/\d/) == -1) {
                callback(new Error(this.$t('msg.Password_format_hint')));
              } else if (value.search(/[a-zA-Z]/) == -1) {
                callback(new Error(this.$t('msg.Password_format_hint')));
              } else if (value.search(/[^a-zA-Z0-9\!\_-]/) != -1) {
                callback(new Error(this.$t('msg.Password_format_hint')));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        price: [
          {
            validator: (rule, value, callback) => {
              if (!value) { callback(); return; }
              if (isNaN(Number(value, 10))) {
                callback(new Error(this.$t('msg.Score_must_be_numeric')));
              }
              if (value.indexOf(".") != -1 && value.split('.').length > 2) {
                callback(new Error(this.$t('msg.Please_enter_the_correct_score_format'))) //防止输入多个小数点
              } else if (value.indexOf(".") != -1 && value.split('.')[1].length > 3) {
                callback(new Error(this.$t('msg.Enter_up_to_three_decimal_places'))) //小数点后三位
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        pnum: [
          {min: 11, max: 11, message: this.$t('msg.The_length_is_11_characters'), trigger: 'blur'},
        ]
      },
      pendingUserId: null,
      dialogFormVisible: false,
      coins: JSON.parse(localStorage.getItem('userInfo')).coins,
      proxyAct: [
        {
          label: 'addProxyDialogFormVisible',
          msg: this.$t('msg.Add_Agent')
        },
        {label: 'getPorxyUserList', msg: this.$t('msg.Reload_agent_List')},
      ],
      userAct: [
        ...(this.level !== 1 ? [{label: 'addDialogFormVisible', msg: this.$t('msg.Add_Player')}] : []),
        {label: 'allQueryReport', msg: this.$t('msg.Player_total_report')},
        {label: 'permissionAllUser', msg: this.$t('msg.Enable_all_player')},
        {label: 'banAllUser', msg: this.$t('msg.Disable_all_player')},
        {label: 'getUserList', msg: this.$t('msg.Reload_player_List')},
      ]
    }
  },
  methods: {
    getPorxyUserList(act = 0) {
      var params = {"search_username": this.searchUsername, "page": this.porxyPage}
      GetPorxyUserList(params).then((data) => {
        if (data.data.errcode === 0 && data.data.params.status === 0) {
          this.porxyTableData = data.data.params.data
          this.porxyTotal = data.data.params.total
          if (act) {
            this.$message({
              message: this.$t('msg.Get_data_successfully'),
              type: 'success',
              offset: 80
            });
          }
        } else {
          msg = data.data.params.msg
          if (!data.data.params.msg) {
            var msg = this.$t('msg.Failed_to_get_agent')
          }
          this.$message({
            message: msg,
            type: 'error',
            offset: 80
          });
        }
      })
    },
    createProxy() {
      var val = true
      var from = 'proxy'
      this.$refs[from].validate(valid => {
        if (!valid) {
          // 表单验证失败，显示错误消息...
          val = false
        }
      })
      if (Number(this.porxyForm.price, 10) > this.coins) {
        val = false
        this.$message({
          message: this.$t('msg.Exceeding_the_maximum_value'),
          type: 'error',
          offset: 80
        });
      }
      if (this.porxyForm.price && Number(this.porxyForm.price, 10) <= 0) {
        val = false
        this.$message({
          message: this.$t('msg.Score_must_be_positive'),
          type: 'error',
          offset: 80
        });
      }
      //添加代理
      if (val) {
        var params = {
          "add_username": this.porxyForm.username,
          "password": this.porxyForm.password,
          "price": this.porxyForm.price || 0,
          "realname": this.porxyForm.realname,
          "pnum": this.porxyForm.pnum,
          "description": this.porxyForm.description,
        }
        var order_id = ''
        if (parseInt(params.price) > 0) {
          order_id = Math.floor((Math.random() + Math.floor(Math.random() * 9 + 1)) * Math.pow(10, 9))
        }
        params["order_id"] = order_id
        CreateProxy(params).then((data) => {
          if (data.data.errcode === 0 && data.data.params.status === 0) {
            this.$message({
              message: this.$t('msg.Add_successfully'),
              type: 'success',
              offset: 80
            });
            this.porxyDialogFormVisible = false
            var userInfo = JSON.parse(localStorage.getItem('userInfo'))
            userInfo['coins'] = data.data.params.coins
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
            this.coins = data.data.params.coins
            this.getPorxyUserList()
            this.porxyForm = {
              'username': '',
              'password': '',
              'price': '',
              'realname': '',
              'pnum': '',
              'description': ''
            }
          } else {
            msg = data.data.params.msg
            if (!data.data.params.msg) {
              var msg = this.$t('msg.Failed_to_add_agent')
            }
            this.$message({
              message: msg,
              type: 'error',
              offset: 80
            });
          }
        })
      }
    },
    handleCurrentChange(val) {
      this.porxyPage = val
      this.getPorxyUserList()
    },
    getUserList(act = 0) {
      var params = {"search_username": this.searchUsername, "page": this.userPage}
      GetUserList(params).then((data) => {
        if (data.data.errcode === 0 && data.data.params.status === 0) {
          this.userTotal = data.data.params.total
          var tableData = data.data.params.data
          for (var i = 0; i < tableData.length; i++) {
            if (tableData[i].lastlogin) {
              var timestamp = tableData[i].lastlogin
              let date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
              var day = 1000 * 60 * 60 * 24;
              var now = new Date().getTime();
              var diffValue = now - date;
              var dayC = diffValue / day;
              // let Y = date.getFullYear() + '-';
              // let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
              // let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
              // let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
              // let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
              // let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
              tableData[i]["lastlogin"] =  this.$t('msg.off') + parseInt(dayC) + this.$t('msg.days');
            } else {
              tableData[i]["lastlogin"] = ''
            }
          }
          this.userTableData = tableData
          if (act) {
            this.$message({
              message: this.$t('msg.Get_data_successfully'),
              type: 'success',
              offset: 80
            });
          }
        } else {
          msg = data.data.params.msg
          if (!data.data.params.msg) {
            var msg = this.$t('msg.Failed_to_get_player')
          }
          this.$message({
            message: msg,
            type: 'error',
            offset: 80
          });
        }
      })
    },
    addDialogFormVisible() {
      getUserId({}).then((data) => {
        if (data.data.errcode === 0 && data.data.params.status === 0) {
          this.pendingUserId = data.data.params.user_id
          this.dialogFormVisible = true
          this.coins = JSON.parse(localStorage.getItem('userInfo')).coins
        } else {
          const msg = (data.data.params && data.data.params.msg) || 'ID池为空，请先在ID池管理页补充普通号'
          this.$message({ message: msg, type: 'error', offset: 80 })
        }
      })
    },
    addProxyDialogFormVisible() {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'))
      var level = userInfo.level
      // var limit = {5: 100, 4: 100, 3: 100, 2: 100}[level]
      // if (this.porxyTableData.length >= limit) {
      //   this.$alert(this.$t('msg.Limit_reached'), '', {
      //     confirmButtonText: this.$t('msg.OK2'),
      //     customClass:'alert'//添加类名
      //
      //   });
      //   return
      // }
      this.porxyDialogFormVisible = true;
      this.coins = userInfo.coins
    },
    createUser() {
      var val = true
      var from = 'user'
      this.$refs[from].validate(valid => {
        if (!valid) {
          // 表单验证失败，显示错误消息...
          val = false
        }
      })
      if (Number(this.userForm.price, 10) > this.coins) {
        this.$message({
          message: this.$t('msg.Exceeding_the_maximum_value'),
          type: 'error',
          offset: 80
        });
        val = false
      }
      if (this.userForm.price && Number(this.userForm.price, 10) <= 0) {
        val = false
        this.$message({
          message: this.$t('msg.Score_must_be_positive'),
          type: 'error',
          offset: 80
        });
      }
      //添加玩家
      if (val) {
        var params = {
          "user_id": this.pendingUserId,
          "password": this.userForm.password,
          "price": this.userForm.price || 0,
          "realname": this.userForm.realname,
          "pnum": this.userForm.pnum,
          "description": this.userForm.description,
        }
        var order_id = ''
        if (parseInt(params.price) > 0) {
          order_id = Math.floor((Math.random() + Math.floor(Math.random() * 9 + 1)) * Math.pow(10, 9))
        }
        params["order_id"] = order_id
        CreateUser(params).then((data) => {
          if (data.data.errcode === 0 && data.data.params.status === 0) {
            this.$message({
              message: this.$t('msg.Add_successfully'),
              type: 'success',
              offset: 80
            });
            var userInfo = JSON.parse(localStorage.getItem('userInfo'))
            userInfo['coins'] = data.data.params.coins
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
            this.coins = data.data.params.coins
            this.getUserList()
          } else {
            msg = data.data.params.msg
            if (!data.data.params.msg) {
              var msg = this.$t('msg.Failed_to_add_player')
            }
            this.$message({
              message: msg,
              type: 'error',
              offset: 80
            });
          }
          this.dialogFormVisible = false
          this.pendingUserId = null
          this.userForm = {
            'password': '',
            'price': '',
            'realname': '',
            'pnum': '',
            'description': ''
          }
        })
      }
    },
    editUser(user_id) {
      this.$router.push({name: 'editUser', query: {'user_id': user_id}})
    },
    editProxy(username) {
      this.$router.push({name: 'editProxy', query: {'proxyName': username}})
    },
    queryReport(sid, user_type) {
      if (user_type==1){
        this.$router.push({name: 'allQueryReport', query: {'sid': sid, 'user_type': user_type}})
      }else{
        this.$router.push({name: 'queryReport', query: {'sid': sid, 'user_type': user_type}})
      }
    },
    allQueryReport(sid, user_type) {
      this.$router.push({name: 'allQueryReport', query: {'sid': sid, 'user_type': user_type}})
    },
    permissionUser(user_id) {
      this.$confirm(this.$t('msg.Confirm_enable_user'), '', {
        confirmButtonText: this.$t('msg.OK2'),
        cancelButtonText: this.$t('msg.Cancel'),
        type: 'warning'
      }).then(() => {
        PermissionUser({"user_id": user_id}).then((data) => {
          if (data.data.errcode === 0 && data.data.params.status === 0) {
            this.$message({
              message: this.$t('msg.Modification_successful'),
              type: 'success',
              offset: 80
            });
            this.getUserList()
          } else {
            msg = data.data.params.msg
            if (!data.data.params.msg) {
              var msg = this.$t('msg.Modification_failed')
            }
            this.$message({
              message: msg,
              type: 'error',
              offset: 80
            });
          }
        })
      }).catch(() => {})
    },
    banUser(user_id) {
      this.$confirm(this.$t('msg.Confirm_ban_user'), '', {
        confirmButtonText: this.$t('msg.OK2'),
        cancelButtonText: this.$t('msg.Cancel'),
        type: 'warning'
      }).then(() => {
        BanUser({"user_id": user_id}).then((data) => {
          if (data.data.errcode === 0 && data.data.params.status === 0) {
            this.$message({
              message: this.$t('msg.Successful_operation'),
              type: 'success',
              offset: 80
            });
            this.getUserList()
          } else {
            msg = data.data.params.msg
            if (!data.data.params.msg) {
              var msg = this.$t('msg.Modification_failed')
            }
            this.$message({
              message: msg,
              type: 'error',
              offset: 80
            });
          }
        })
      }).catch(() => {})
    },
    banProxy(username) {
      if (username === this.username) {
        this.$message({ message: this.$t('msg.Cannot_ban_self'), type: 'warning', offset: 80 });
        return;
      }
      this.$confirm(this.$t('msg.Confirm_ban_proxy'), '', {
        confirmButtonText: this.$t('msg.OK2'),
        cancelButtonText: this.$t('msg.Cancel'),
        type: 'warning'
      }).then(() => {
        BanProxy({"search_username": username}).then((data) => {
          if (data.data.errcode === 0 && data.data.params.status === 0) {
            this.$message({
              message: this.$t('msg.Successful_operation'),
              type: 'success',
              offset: 80
            });
            this.getPorxyUserList()
          } else {
            msg = data.data.params.msg
            if (!data.data.params.msg) {
              var msg = this.$t('msg.Modification_failed')
            }
            this.$message({
              message: msg,
              type: 'error',
              offset: 80
            });
          }
        })
      }).catch(() => {})
    },
    permissionProxy(username) {
      this.$confirm(this.$t('msg.Confirm_enable_proxy'), '', {
        confirmButtonText: this.$t('msg.OK2'),
        cancelButtonText: this.$t('msg.Cancel'),
        type: 'warning'
      }).then(() => {
        PermissionProxy({"search_username": username}).then((data) => {
          if (data.data.errcode === 0 && data.data.params.status === 0) {
            this.$message({
              message: this.$t('msg.Successful_operation'),
              type: 'success',
              offset: 80
            });
            this.getPorxyUserList()
          } else {
            msg = data.data.params.msg
            if (!data.data.params.msg) {
              var msg = this.$t('msg.Modification_failed')
            }
            this.$message({
              message: msg,
              type: 'error',
              offset: 80
            });
          }
        })
      }).catch(() => {})
    },
    userHandleCurrentChange(val) {
      this.userPage = val
      this.getUserList()
    },
    banAllUser() {
      this.$confirm(this.$t('msg.Confirm_ban_all_players'), '', {
        confirmButtonText: this.$t('msg.OK2'),
        cancelButtonText: this.$t('msg.Cancel'),
        type: 'warning'
      }).then(() => {
        BanUser({"search_username": this.searchUsername}).then((data) => {
          if (data.data.errcode === 0 && data.data.params.status === 0) {
            this.$message({
              message: this.$t('msg.Successful_operation'),
              type: 'success',
              offset: 80
            });
            this.getUserList()
          } else {
            msg = data.data.params.msg
            if (!data.data.params.msg) {
              var msg = this.$t('msg.Modification_failed')
            }
            this.$message({
              message: msg,
              type: 'error',
              offset: 80
            });
          }
        })
      }).catch(() => {})
    },
    permissionAllUser() {
      this.$confirm(this.$t('msg.Confirm_enable_all_players'), '', {
        confirmButtonText: this.$t('msg.OK2'),
        cancelButtonText: this.$t('msg.Cancel'),
        type: 'warning'
      }).then(() => {
        PermissionUser({"search_username": this.searchUsername}).then((data) => {
          if (data.data.errcode === 0 && data.data.params.status === 0) {
            this.$message({
              message: this.$t('msg.Successful_operation'),
              type: 'success',
              offset: 80
            });
            this.getUserList()
          } else {
            msg = data.data.params.msg
            if (!data.data.params.msg) {
              var msg = this.$t('msg.Modification_failed')
            }
            this.$message({
              message: msg,
              type: 'error',
              offset: 80
            });
          }
        })
      }).catch(() => {})
    },
    setScore(sid, set_type) {
      this.$router.push({name: 'setScore', query: {'sid': sid, 'set_type': set_type}})
    },
    SetScoreLog(sid, user_type) {
      this.$router.push({name: 'setScoreLog', query: {'sid': sid, 'user_type': user_type}})
    },
    chiAccountList(sid) {
      this.$router.push({name: 'userSearch', query: {'sid': sid, 'user_type': '1'}})
    },
    userSearch(user_id) {
      this.$router.push({name: 'userSearch', query: {'sid': user_id, 'user_type': 0}})
    },
    getUserColWidth() {
      return (5 * 76 + 20) + 'px'
    },
    getProxyColWidth() {
      return this.level === 0 ? (4 * 76 + 20) + 'px' : (3 * 76 + 20) + 'px'
    },
    proxyHandleCommand(command) {
      if (command === 'addProxyDialogFormVisible') {
        this.addProxyDialogFormVisible()
      } else if (command === 'getPorxyUserList') {
        this.getPorxyUserList(1)
      }
    },
    userHandleCommand(command) {
      if (command === 'addDialogFormVisible') {
        if (this.level === 1) return
        this.addDialogFormVisible()
      } else if (command === 'allQueryReport') {
        this.allQueryReport(this.searchUsername, 0)
      } else if (command === 'permissionAllUser') {
        this.permissionAllUser()
      } else if (command === 'banAllUser') {
        this.banAllUser()
      } else if (command === 'getUserList') {
        this.getUserList(1)
      }
    },
    noCheckDevice() {
      return !isMobile()
    },
    checkDevice() {
      return isMobile()
    },
  },
  mounted() {
    if (this.$route.query.pid) {
      this.searchUsername = this.$route.query.pid
    } else {
      var userinfo = JSON.parse(localStorage.getItem('userInfo'))
      if (userinfo.is_sub) {
        this.searchUsername = userinfo.up_username
        this.username = userinfo.up_username
      } else {
        this.searchUsername = localStorage.getItem('username')
        this.username = localStorage.getItem('username')
      }
    }
    //获取数据
    this.getPorxyUserList()
    this.getUserList()

  },
  computed: {
    porxyRulesNoPrice() {
      var r = Object.assign({}, this.porxyRules)
      delete r.price
      return r
    },
    showProxyAct() {
      var p = []
      for (let i = 0; i < this.proxyAct.length; i++) {
        var item = this.proxyAct[i]
        if (item.label === 'addProxyDialogFormVisible' && this.searchUsername == this.username && this.level !== 2) {
          p.push(item)
        }
        if (item.label === 'getPorxyUserList' && this.level !== 2) {
          p.push(item)
        }
      }
      return p
    },
    showUserAct() {
      var p = []
      for (let i = 0; i < this.proxyAct.length; i++) {
        var item = this.proxyAct[i]
        if (item.label === 'addDialogFormVisible' && this.searchUsername == this.username) {
          p.push(item)
        }
        if (item.label === 'allQueryReport') {
          p.push(item)
        }
        if (item.label === 'permissionAllUser' && this.searchUsername == this.username) {
          p.push(item)
        }
        if (item.label === 'banAllUser' && this.searchUsername == this.username) {
          p.push(item)
        }
        if (item.label === 'getUserList') {
          p.push(item)
        }

      }
    }
  },
  watch: {
    '$route'(to, from) {
      this.$router.go(0);
    }
  }

}
</script>

<style lang="less" scoped>
@media screen and (max-width: 500px) {
  .alert {
    width: 240px;
  }
}

.section-card {
  background: #ffffff;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  margin-bottom: 16px;
  overflow: hidden;
}

.button-block {
  height: 44px;
  white-space: nowrap;
  background: #fafafa;
  border-bottom: 1px solid #e4e7ed;
  position: relative;

  &::-webkit-scrollbar {
    display: none;
  }
}

.tag-chile {
  height: 44px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  position: absolute;
  top: 0;
  bottom: 0;
}

.proxyBlock {
  .el-input {
    width: 100%;
  }
}

.el-button + .el-button, .el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0;
}

.tableAuto.el-table .cell {
  white-space: nowrap;
}

.block {
  display: flex;
  justify-content: center;
  padding: 10px 0 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/AccountList.vue